import { API_URL, CUSTOMERS_KEY } from "../keys"
import axios from "axios"


export const getCouponByCode = async (code: string, token: string) => {
    const response = await axios.get(`${API_URL}/coupons/customer`, {
        headers: {
            "sce-api-key": CUSTOMERS_KEY,
            Authorization: `Bearer ${token}`,
        },
        validateStatus: (status) => status < 500,
        params: { code },
    })

    if (response) return response
}